<circle-progress
[percent]="score"
[radius]="30"
[outerStrokeWidth]="4"
[innerStrokeWidth]="4"
[space] = "-4"
[outerStrokeColor]="outerStrokeColor"
[innerStrokeColor]="innerStrokeColor"
[titleFontSize]= "16"
[unitsFontSize]= "16"
[showSubtitle] = "false"
[animation]="false"
[startFromZero]="false"
[responsive]="true"
[subtitleColor]="subtitleColor"
[titleColor]="titleColor"
[title]= "score"
[animation]="true"
[animationDuration]="300"
[animateTitle]="false"
[unitsColor]="unitsColor"
></circle-progress>